import './PointsBalanceCard.css';

type PointsBalanceCardProps = {
  pointsBalance: number;
};

const PointsBalanceCard = ({ pointsBalance }: PointsBalanceCardProps) => (
  <article className="appointments-v2-card points-balance-card">
    <div className="appointments-v2-card-header"><h3>Points balance</h3></div>
    <div className="appointments-v2-card-body points-balance-card__body">
      <div className="points-balance-card__ring">
        <svg className="points-balance-card__ring-svg" viewBox="0 0 80 80" aria-hidden="true">
          <circle cx="40" cy="40" r="34" fill="none" stroke="var(--color-border)" strokeWidth="4" />
          <circle
            cx="40" cy="40" r="34"
            fill="none"
            stroke="var(--color-accent)"
            strokeWidth="4"
            strokeLinecap="round"
            strokeDasharray="213.6"
            strokeDashoffset={213.6 * (1 - Math.min((pointsBalance || 0) / Math.max(pointsBalance || 1000, 1000), 1))}
            transform="rotate(-90 40 40)"
            style={{ transition: 'stroke-dashoffset 600ms ease' }}
          />
        </svg>
        <span className="points-balance-card__ring-value">{Math.trunc(pointsBalance || 0)}</span>
      </div>
      <p className="points-balance-card__label">Current balance</p>
    </div>
  </article>
);

export default PointsBalanceCard;
